import { gql } from '@apollo/client';

/**
 * 根据途径点ID分页查询装车包裹明细（直接查询tms_loading_order_detail表）
 * 不包含overallStatus筛选时使用此接口，性能更好
 */
export const GET_LOADING_ORDER_DETAILS_BY_WAYPOINT_ID = gql`
    query GetLoadingOrderDetailsByWaypointId(
        $waypointId: Long!
        $pageRequest: PageRequestTypeInput
        $trackingNumber: String
        $sortingCode: String
        $overallStatus: String
    ) {
        getLoadingOrderDetailsByWaypointId(
            waypointId: $waypointId
            pageRequest: $pageRequest
            trackingNumber: $trackingNumber
            sortingCode: $sortingCode
            overallStatus: $overallStatus
        ) {
            content {
                id
                trackingNumber
                overallStatus
                sortingCode
                bagNumber
                bagTaskNumber
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface LoadingOrderDetailInfoType {
    id: string;
    trackingNumber: string;
    overallStatus: string;
    sortingCode: string | null;
    bagNumber: string;
    bagTaskNumber: string | null;
}

export interface GetLoadingOrderDetailsByWaypointIdResponse {
    getLoadingOrderDetailsByWaypointId: {
        content: LoadingOrderDetailInfoType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetLoadingOrderDetailsByWaypointIdVariables {
    waypointId: number;
    pageRequest?: {
        page: number;
        size: number;
    };
    trackingNumber?: string;
    sortingCode?: string;
    overallStatus?: string;
}

